export const appData = {
  name: "Interactive Fantasy App",
  developer: "Lovescape Studios",
  shortDescription: "Personalized interactive fantasy with customizable characters and branching stories.",
  rating: 4.9,
  reviews: "8.36M reviews",
  downloads: "500M+",
  labels: ["18+", "In-app purchases"],
  icon: "/icon-new.png",
  
  screenshots: [
    "https://customer-assets.emergentagent.com/job_adult-fantasy-app/artifacts/il85yjlb_app1.png",
    "https://customer-assets.emergentagent.com/job_adult-fantasy-app/artifacts/0y5o1473_app2.png",
    "https://customer-assets.emergentagent.com/job_adult-fantasy-app/artifacts/6f8h5fjb_app3.png",
    "https://customer-assets.emergentagent.com/job_adult-fantasy-app/artifacts/juugnrzz_app4.png",
    "https://customer-assets.emergentagent.com/job_adult-fantasy-app/artifacts/koz4ulff_app5.png"
  ],
  
  features: [
    "Customizable characters and scenes",
    "Branching storylines and choices",
    "Gallery and quick scenarios",
    "\"Quick Start\" mode in under 15 seconds",
    "Works offline after installation"
  ],
  
  aboutDescription: "Sex Stimulator is an interactive fantasy experience for adults. You create scenes, adjust character behavior, and shape the story through your choices. The narrative engine reacts dynamically to your decisions, while flexible settings ensure you get the experience you want. Simple interface, instant launch. Requires users 18+.",
  
  userReviews: [
    {
      id: 1,
      author: "FantasyLover23",
      date: "15.07.2025",
      rating: 5,
      text: "Flexible customization and quick start. Exactly what I wanted.",
      avatar: "F"
    },
    {
      id: 2,
      author: "StoryExplorer",
      date: "14.07.2025",
      rating: 5,
      text: "The branching stories actually work. Impressive execution.",
      avatar: "S"
    },
    {
      id: 3,
      author: "GameOptimizer",
      date: "13.07.2025",
      rating: 5,
      text: "Great optimization, smooth and fast.",
      avatar: "G"
    }
  ],
  
  ratingDistribution: {
    5: 85,
    4: 10,
    3: 3,
    2: 1,
    1: 1
  },
  
  redirectUrl: "https://go.xlvirdr.com/ls?campaignId=simulator&sourceId=facebook&userId=847e9325a3b39b98e2a56ad49c76af2b3e064c81f7bae1a6f8173a74c292fffc&path=create-ai-sex-girlfriend/",
  loadingPageUrl: "https://sex.lovescape.space/",
  videoUrl: "https://cdn.lovescape.com/cdn/front/videos/marketing/introvideo.mp4"
};